import ApiService from "@/services/api.service";
import Vue from "vue";

const route = 'contracts';

const branches = {
    all(_limit, _currentPage, _params, _orderBy, _orderDirection) {
        return new Promise((resolve, reject) => {
            var params = "?limit=" + _limit + "&page=" + _currentPage;

            if(_params.date)
                if (_params.date[0] && _params.date[1] && _params.date_by)
                    params += "&date_init_at=" + Vue.moment(_params.date[0]).format('YYYY-MM-DD')
                            + "&date_end_at=" + Vue.moment(_params.date[1]).format('YYYY-MM-DD')
                            + "&date_by=" + _params.date_by;

            if (_params.status != "")
                params += "&contract_status_id=" + _params.status;

            if(_params.client != "")
                params += "&client_name=" + encodeURI(_params.client);

            if(_params.representative != "0")
                params += "&representative_id=" + encodeURI(_params.representative);

            if(_params.physical_proposal != "")
                params += "&physical_proposal=" + encodeURI(_params.physical_proposal);

            if(_params.situation != "")
                params += "&situation=" + encodeURI(_params.situation);

            if(_params.group != "")
                params += "&group=" + encodeURI(_params.group);

            if(_params.quota != "")
                params += "&quota=" + encodeURI(_params.quota);

            if (_params.show_me_all_for_me != "")
                params += "&show_me_all_for_me=" + encodeURI(_params.show_me_all_for_me);

            if (_orderBy != undefined && _orderBy != ""){
                params += "&orderBy=" + _orderBy + "&orderDirection=" + _orderDirection
            }

            ApiService.get(route + params).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    downloadFull(_id) {
        return new Promise((resolve, reject) => {
            ApiService.download(route, + _id + "/downloadFull").then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    get(_id) {
        return new Promise((resolve, reject) => {
            ApiService.get(route, _id).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    add(_module) {
        return new Promise((resolve, reject) => {
            ApiService.post(route, _module).then(({ data}) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    edit(_id, _module) {
        return new Promise((resolve, reject) => {
            ApiService.patch(route, _id, _module).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    rem(_id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(route, _id)
                    .then(({ data }) => {
                        resolve(data);
                    }, (error) => {
                        reject(error);
                    });
        });
    },
    sendDocument(_id, _module) {
        return new Promise((resolve, reject) => {
            ApiService.post(route + '/' + _id + '/documents', _module).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
};

export default branches;